import React, { useState, useEffect, useMemo } from 'react';
import {
  startOfWeek,
  endOfWeek,
  getWeek,
  getYear,
  addMonths,
  subMonths,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isSameMonth,
  isSameDay,
  format,
  parseISO,
  isAfter,
  isDate,
  isBefore
} from 'date-fns';
import { ptBR } from 'date-fns/locale';
import './Calendar.css';
import { useTranslation } from 'react-i18next';
import Translator from '../I18n/Translator';
import { getEpidemiologicalWeek } from '../EpidemiologicalWeek';

const Calendar = ({ onWeekSelect, isFloating = false, selectedWeek: externalSelectedWeek, initialDate, finalDay }) => {
  const [currentDate, setCurrentDate] = useState(initialDate);
  const [finalDate, setfinalDate] = useState(finalDay);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const { t } = useTranslation();
  // Sincronizar com a semana selecionada externamente
  useEffect(() => {
    if (externalSelectedWeek) {
      setSelectedWeek(externalSelectedWeek);
    }
    
  }, [externalSelectedWeek]);

  useEffect(() => {
  if (selectedWeek) {
    setCurrentDate(selectedWeek.sunday); 
  }
}, [selectedWeek]);

  // Função para calcular a semana epidemiológica usando moment.js
  /*const getEpidemiologicalWeek = (date) => {
    
    const sunday = startOfWeek(date, { weekStartsOn: 0 });
    const mom = moment(sunday);
    return { year: mom.weekYear(), week: mom.week() };
  };*/

  // Função para obter o domingo da semana de uma data usando date-fns
  const getSundayOfWeek = (date) => {
    return startOfWeek(date, { weekStartsOn: 0 }); // 0 para domingo
  };

  // Função para obter o sábado da semana de uma data usando date-fns
  const getSaturdayOfWeek = (date) => {
    return endOfWeek(date, { weekStartsOn: 0 }); // 0 para domingo
  };

  // Função para gerar os dias do mês usando date-fns
  const generateCalendarDays = () => {
    const start = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 0 });
    const end = endOfWeek(endOfMonth(currentDate), { weekStartsOn: 0 });
    
    

    return eachDayOfInterval({ start, end });

  };

  // Função para verificar se uma data está na semana selecionada
  const isInSelectedWeek = (date) => {
    if (!selectedWeek) return false;
    const sundayOfDate = getSundayOfWeek(date);
    return isSameDay(selectedWeek.sunday, sundayOfDate);
  };

  // Função para lidar com o clique em um dia
  const handleDayClick = (date) => {
    const sunday = getSundayOfWeek(date);
    const saturday = getSaturdayOfWeek(date);
    const epidWeek = getEpidemiologicalWeek(date);

    const weekData = {
      sunday,
      saturday,
      epidemiologicalWeek: epidWeek,
      dates: eachDayOfInterval({ start: sunday, end: saturday })
    };

    setSelectedWeek(weekData);

    if (onWeekSelect) {
      onWeekSelect(weekData);
    }
  };

  // Função para navegar entre meses usando date-fns
  const navigateMonth = (direction) => {
    const newDate = direction === -1 ? subMonths(currentDate, 1) : addMonths(currentDate, 1);
    setCurrentDate(newDate);
  };

  const days = generateCalendarDays();
  const monthNames = t('dashboard.calendar.titulo_meses', { returnObjects: true })
  const dayNames = t('dashboard.calendar.titulo_dias', { returnObjects: true });



  return (
    <div className={`epidemiological-calendar ${isFloating ? 'floating-mode' : ''}`}>
      <div className="calendar-header">
        <button
          className="nav-button"
          onClick={() => navigateMonth(-1)}

        >
          ←
        </button>
        <h2 className="month-year">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h2>
        <button
          className="nav-button"
          onClick={() => navigateMonth(1)}
        >
          →
        </button>
      </div>

      <div className="calendar-grid">
        {dayNames.map(day => (
          <div key={day} className="day-header">
            {day}
          </div>
        ))}

        {days.map((date, index) => {
          const isCurrentMonth = isSameMonth(date, currentDate);
          const isSelected = isInSelectedWeek(date);
          const epidWeek = getEpidemiologicalWeek(date);
          const isDisabled = isBefore(date, initialDate) || isAfter(date,finalDate);

          return (
            <div
              key={index}
              className={`calendar-day 
        ${isCurrentMonth ? 'current-month' : 'other-month'} 
        ${isSelected ? 'selected-week' : ''} 
        ${isDisabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!isDisabled) handleDayClick(date);
              }}
              title={`${t('dashboard.semana_ep')}: ${epidWeek.week}/${epidWeek.year}`}
            >
              <span className="day-number">{format(date, 'd')}</span>
              <span className="week-number">{t('dashboard.calendar.sigle_se')} {epidWeek.week}</span>
            </div>
          );
        })}

      </div>

      {selectedWeek && !isFloating && (
        <div className="selected-week-info">
          <h3>{t('dashboard.calendar.titulo_se_selected')}</h3>
          <p>
            <strong>{t('dashboard.calendar.sigle_se')} {selectedWeek.epidemiologicalWeek.week}/{selectedWeek.epidemiologicalWeek.year}</strong>
          </p>
          <p>
            {format(selectedWeek.sunday, 'dd/MM/yyyy', { locale: ptBR })} - {format(selectedWeek.saturday, 'dd/MM/yyyy', { locale: ptBR })}
          </p>
        </div>
      )}
    </div>
  );
};

export default Calendar;


